module.exports = __webpack_public_path__ + "static/media/B6.75ac0c34.jpg";